import { type User, UserSchema } from '@scoring/types';
import { queryKeys } from '../../queries/queryKeys';
import { useApiQuery } from '../../queries/useApiQuery';
import { get } from '../../queries';
import React from 'react';

export const useUserByIdQuery = () => {
    const [userId, setUserId] = React.useState<string | null | undefined>(undefined);

    const query = useApiQuery<User>({
        queryKey: userId ? queryKeys.users.single(userId) : queryKeys.users.singleAll(),
        queryFn: () => get(`users/${userId}`, undefined, GetUserResponseSchema),
        queryOptions: { enabled: !!userId, refetchOnWindowFocus: false },
    });

    return {
        ...query,
        setUserId,
    };
};

const GetUserResponseSchema = UserSchema;
